import axios from 'axios';

const API_URL = process.env.API_URL;

export async function getListTopEarningArtist(authorization) {
  const url = `${API_URL}/admin/statistic/top-earning`;
  return axios({
    url,
    method: 'get',
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getListTopCountry(authorization, isArtist) {
  const url = `${API_URL}${isArtist ? '/dashboard/statistic/top-country' : '/admin/statistic/top-country'}`;
  return axios({
    url,
    method: 'get',
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function getArtistBalance(authorization, artist_id) {
  const url = `${API_URL}/dashboard/artist/${artist_id}/balance`;
  return axios({
    url,
    method: 'get',
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function getEarningToDate(authorization) {
  const url = `${API_URL}/dashboard/statistic/earning-to-date`;
  return axios({
    url,
    method: 'get',
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function getPopularSong(authorization, isArtist, lifetimeStatus = 0) {
  const url = `${API_URL}${isArtist ? '/dashboard/statistic/popular-song' : '/admin/statistic/popular-song'}`;
  return axios({
    url,
    method: 'get',
    params: { lifetime: lifetimeStatus },
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function getPopularAlbum(authorization, isArtist, lifetimeStatus = 0) {
  const url = `${API_URL}${isArtist ? '/dashboard/statistic/popular-album' : '/admin/statistic/popular-album'}`;
  return axios({
    url,
    method: 'get',
    params: { lifetime: lifetimeStatus },
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function getWeeklyCustomer(authorization, isArtist) {
  const url = `${API_URL}${isArtist ? '/dashboard/statistic/weekly-customer' : '/admin/statistic/weekly-customer'}`;
  return axios({
    url,
    method: 'get',
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function getSoldSong(authorization, isArtist) {
  const url = `${API_URL}${isArtist ? '/dashboard/statistic/sold-song' : '/admin/statistic/sold-song'}`;
  return axios({
    url,
    method: 'get',
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getTopSubscriberCountry(authorization, filter) {
  const url = `${API_URL}/admin/statistic/top-subscriber-country`;
  return axios({
    url,
    method: 'get',
    params: {from_date: filter.start_date,to_date: filter.end_date },
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getWeeklySubscriber(authorization, filter) {
  const url = `${API_URL}/admin/statistic/weekly-subscriber`;
  return axios({
    url,
    method: 'get',
    params: {from_date: filter.start_date,to_date: filter.end_date },
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getPopularAlbumByPlay(authorization) {
  const url = `${API_URL}/admin/statistic/popular-album-play`;
  return axios({
    url,
    method: 'get',
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getPopularSongByPlay(authorization) {
  const url = `${API_URL}/admin/statistic/popular-song-play`;
  return axios({
    url,
    method: 'get',
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}



// WEBPACK FOOTER //
// ./src/services/statistic.js